import { render, staticRenderFns } from "./HttpHeaders.vue?vue&type=template&id=79d2ec2c"
import script from "./HttpHeaders.vue?vue&type=script&lang=js"
export * from "./HttpHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports